import React, { ReactNode, FC } from "react";
import { SettingsSubsectionTitle } from "@/pages/settings/components/SettingsSubsectionTitle";
import styled from "@emotion/styled";

interface SettingsSubsectionWrapperProps extends React.PropsWithChildren {
  title: ReactNode;
  titleClassName?: string;
  className?: string;
}

export const SettingsSubsectionWrapper: FC<SettingsSubsectionWrapperProps> = ({
  title,
  children,
  titleClassName,
}) => {
  return (
    <Wrapper>
      <SettingsSubsectionTitle title={title} className={titleClassName} />
      <ChildrenWrapper>{children}</ChildrenWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  flexWrap: "nowrap",
  width: "100%",
});

const ChildrenWrapper = styled.div`
  display: flex;
  padding: ${({ theme }) => theme.spacing[2]} 0;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing[2]};
  align-self: stretch;
`;
